import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * Floating "Back to Sasha" button that surfaces on every page EXCEPT the
 * chat page itself (where it would be redundant). Lives bottom-left so it
 * doesn't collide with the bottom-right "Install Sasha" PWA prompt.
 *
 * Design note: gold pill on emerald background, scallop animation on hover
 * so the icon feels alive. The button is hidden on the chat route so guests
 * don't see "Back to Sasha" while already talking to Sasha.
 */
export default function BackToSashaButton() {
  const { pathname } = useLocation();
  const isSashaPage = ["/", "/talk-to-sasha", "/Talk-To-Sasha", "/Talk-to-Sasha", "/chat"].includes(pathname);
  if (isSashaPage) return null;

  return (
    <Link
      to="/Talk-To-Sasha"
      className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-[55] inline-flex items-center gap-2 px-4 py-3 bg-[var(--emerald)] text-[var(--ivory)] shadow-2xl border-t-2 border-[var(--gold)] hover:bg-[var(--brand-red)] transition-colors group"
      data-testid="back-to-sasha-fab"
      aria-label="Back to Sasha"
    >
      <Sparkles
        size={14}
        strokeWidth={1.5}
        className="text-[var(--gold)] group-hover:text-[var(--ivory)] transition-colors"
      />
      <span className="text-[11px] uppercase tracking-[0.22em] font-medium">
        Back to Sasha
      </span>
    </Link>
  );
}
